<template>
  <svg
    width="36"
    height="46"
    viewBox="0 0 36 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.41658 28.7279C0.812415 28.7279 -0.645918 25.707 1.02075 23.6237L20.0832 1.54036C22.0624 -0.855468 25.8124 0.707032 25.6041 3.72787L24.5624 16.0195C24.5624 16.6445 24.9791 17.1654 25.6041 17.1654H32.5832C35.1874 17.1654 36.6457 20.1862 34.9791 22.2695L15.9166 44.457C13.9374 46.8529 10.1874 45.2904 10.3957 42.2695L11.4374 29.9779C11.4374 29.3529 11.0207 28.832 10.3957 28.832H3.41658V28.7279Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ProductMenuIcon2',
} as DefineComponent
</script>
